import React, {Component} from 'react'
import FormRow from "../form/row.component.jsx"
import {defineMessages, FormattedMessage, injectIntl} from "react-intl";
import ActionButton from "../button/actionbutton.component.jsx"
import $ from 'jquery'
import ReactFlagsSelect from 'react-flags-select'
import 'react-flags-select/scss/react-flags-select.scss'
import './country-selector.scss'
import Icon from "../icon/icon.component.jsx";

const messages = defineMessages({
    card_number_placeholder: {
        id: 'credit_card.paysafe.card_number_placeholder',
        defaultMessage: 'Card number',
    },
    expiry_date_placeholder: {
        id: 'credit_card.paysafe.expiry_date_placeholder',
        defaultMessage: 'MM / YY',
    },
    cvc_placeholder: {
        id: 'credit_card.paysafe.cvc_placeholder',
        defaultMessage: 'CVC',
    },
    cardholder_name_placeholder: {
        id: 'credit_card.paysafe.cardholder_name_placeholder',
        defaultMessage: 'Cardholder name',
    },
    postal_code_placeholder: {
        id: 'credit_card.paysafe.postal_code_placeholder',
        defaultMessage: 'Postal code',
    },
})

class PaysafeCreditCardForm extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            name: '',
            postalCode: '',
            countryCode: this.props.countryCode || 'US',
            testMode: this.props.testMode || false,
            apiKey: this.props.apiKey || '',
            onSubmit: this.props.onSubmit || function () {},
            submitButtonStyle: this.props.submitButtonStyle || {},
            submitButton: this.props.submitButton || <FormattedMessage
                id="common.credit_card.confirm_label"
                defaultMessage="Confirm"
            />,
            submitButtonLoading: false,
            submitDisabled: this.props.submitDisabled || false,
            amount: this.props.amount || '0',
            currency: this.props.currency,
            merchantId: this.props.merchantId,
            creditCardType: <Icon value={'credit-card'} />,
            saveCard: this.props.saveCard || false,
        }

        this.instance = null
        this.name = this.props.name
        this.placeholder = this.props.placeholder
        this.handleSubmit = this.handleSubmit.bind(this)
        this.setup = this.setup.bind(this)
        this.onPaysafeLoad = this.onPaysafeLoad.bind(this)
        this.handleResult = this.handleResult.bind(this)
        this.creditCardUpdate = this.creditCardUpdate.bind(this)
    }

    componentDidMount() {
        this.setup()
    }

    onPaysafeLoad(instance, error) {
        if (!error) {
            instance.fields("cvv cardNumber expiryDate").valid(function (eventInstance, event) {
                $(event.target.containerElement).closest('.form-control').removeClass('border-danger').addClass('border-success');
            })

            instance.fields("cvv cardNumber expiryDate").invalid(function (eventInstance, event) {
                $(event.target.containerElement).closest('.form-control').addClass('border-danger').removeClass('border-success');
            })

            instance.fields.cardNumber.on("FieldValueChange", this.creditCardUpdate)
            this.instance = instance

        }
    }

    creditCardUpdate(instance, event) {
        let iconType = 'credit-card'
        if (!instance.fields.cardNumber.isEmpty() && instance.getCardBrand()) {
            const cardBrand = instance.getCardBrand().replace(/\s+/g, '');
            switch (cardBrand) {
                case "AmericanExpress":
                    iconType = 'cc-amex'
                    break;
                case "MasterCard":
                    iconType = 'cc-mastercard'
                    break;
                case "Visa":
                    iconType = 'cc-visa'
                    break;
                case "Diners":
                    iconType = 'cc-diners-club'
                    break;
                case "JCB":
                    iconType = 'cc-jcb'
                    break;
                case "Maestro":
                    iconType = 'cc-discover'
                    break;
            }
        }
        this.setState({
            creditCardType: <Icon value={iconType} />,
        })
    }

    setup() {
        if (!this.state.apiKey || this.instance) {
            return
        }
        var options = {
            environment: this.state.testMode ? "TEST" : "LIVE",
            fields: {
                cardNumber: {
                    selector: "#cardNumber",
                    placeholder: this.props.intl.formatMessage(messages.card_number_placeholder)
                },
                expiryDate: {
                    selector: "#cardExpiry",
                    placeholder: this.props.intl.formatMessage(messages.expiry_date_placeholder)
                },
                cvv: {
                    selector: "#cardCVC",
                    placeholder: this.props.intl.formatMessage(messages.cvc_placeholder)
                }
            }
        }
        paysafe.fields.setup(this.state.apiKey, options, this.onPaysafeLoad)

    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            submitDisabled: nextProps.submitDisabled || false,
            testMode: nextProps.testMode || false,
            apiKey: nextProps.apiKey || false,
            amount: nextProps.amount || '0',
            currency: nextProps.currency,
            merchantId: nextProps.merchantId,
            saveCard: nextProps.saveCard || false,
        })
    }

    handleSubmit(event) {
        this.setState({submitButtonLoading : true})
        event.preventDefault()
        if (!this.instance) {
            return
        }
        this.instance.tokenize({
            vault: {
                holderName: this.state.name,
                billingAddress: {
                    zip: this.state.postalCode,
                    country: this.state.countryCode,
                }
            },
            // threeDS: {
            //     amount: parseFloat(this.state.amount)*100,
            //     currency: this.state.currency,
            //     useThreeDSecureVersion2: true,
            //     accountId: parseInt(this.state.merchantId),
            // },
        }, this.handleResult)
    }

    handleResult(instance, error, result) {
        const token = result ? result.token : null
        if (error) {
            error.message = error.detailedMessage
        }
        this.state.onSubmit(
            null, {
            id: token,
            token: token,
            billingDetails: {
                name: this.state.name,
                address: {
                    postalCode: this.state.postalCode,
                    countryCode: this.state.countryCode,
                }
            },
            saveCard: this.state.saveCard,
        }, this.state.saveCard, error, () => {
            this.setState({
                submitButtonLoading: false,
            })
        })
    }

    render() {
        return (
            <form role="form" id="payment-form" method="POST">
                <FormRow
                    className={"mb-0"}
                    style={"rows"}
                    name={"name"}
                    label={<FormattedMessage
                        id="common.credit_card.name_label"
                        defaultMessage="Cardholder name"
                    />}
                    input={<input
                        required
                        id={"name"}
                        type={"text"}
                        className="form-control"
                        placeholder={this.props.intl.formatMessage(messages.cardholder_name_placeholder)}
                        onChange={e => {
                            this.setState({
                                name: e.target.value
                            })
                    }} />}
                />
                <FormRow
                    className={"mb-0"}
                    style={"rows"}
                    name={"name"}
                    label={<FormattedMessage
                        id="common.credit_card.credit_card_number_label"
                        defaultMessage="Credit card number"
                    />}
                    input={<div className="input-group">
                        <div className="form-control" id="cardNumber" style={{height: '2.35rem'}} />
                        <div className="input-group-append">
                            <span className="input-group-text" >
                                {this.state.creditCardType}
                            </span>
                        </div>
                    </div>}
                />
                <div className="row pt-3 pb-1">
                    <div className={"col-12 d-flex"}>
                        <div className="form-group mb-0 mr-3 flex-fill">
                            <div
                                style={{height: '2.35rem', width: '6rem'}}
                                className="form-control"
                                id="cardExpiry"
                            />
                        </div>
                        <div className="form-group mb-0 mr-3 flex-fill">
                            <div
                                style={{height: '2.35rem', width: '5rem'}}
                                className="form-control"
                                id="cardCVC"
                            />
                        </div>
                        <div className="form-group mb-0 flex-fill">
                            <div className="input-group">
                                <input
                                    maxLength={6}
                                    required
                                    id={"postalCode"}
                                    placeholder={this.props.intl.formatMessage(messages.postal_code_placeholder)}
                                    type={"text"}
                                    className="form-control"
                                    style={{minWidth: '7rem'}} onChange={e => {
                                    this.setState({
                                        postalCode: e.target.value
                                    })
                                }} />
                                <div className="input-group-append">
                                    <div className="input-group-text p-0" >
                                        <ReactFlagsSelect
                                            placeholder="-"
                                            defaultCountry={this.state.countryCode}
                                            searchable={true}
                                            showSelectedLabel={false}
                                            onSelect={code => {
                                                this.setState({countryCode: code})
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                {this.props.children}
                <div className={"row py-2 mt-2"}>
                    <div className={"col-12 col-md-6 d-flex align-items-center justify-content-start flex-wrap mb-2"}>
                        <a href="https://www.paysafe.com/en/" target={'_blank'} className={'mr-2'}>
                            <img src="/images/powered_by_paysafe_logo.png" border="0" width="80" alt="Powered by Paysafe" />
                        </a>
                        <img src={'/images/credit_cards/1.png'} width={'30px'} className={'mr-1'} />
                        <img src={'/images/credit_cards/2.png'} width={'30px'} className={'mr-1'} />
                        <img src={'/images/credit_cards/22.png'} width={'30px'} className={'mr-1'} />
                    </div>
                    <div className={"col-12 col-md-6"}>
                        <ActionButton
                            id={'payButton'}
                            type="button"
                            loadingTimeout={30000}
                            className="btn btn-primary w-100 pay"
                            style={this.state.submitButtonStyle}
                            onClick={this.handleSubmit}
                            isLoading={this.state.submitButtonLoading}
                            disabled={this.state.submitDisabled}
                        >
                            {this.state.submitButton}
                        </ActionButton>
                    </div>
                </div>
            </form>
        )
    }
}

export default injectIntl(PaysafeCreditCardForm)





// WEBPACK FOOTER //
// ./src/common/credit-card/paysafe.component.jsx